import { render, staticRenderFns } from "./gc-button-delete.vue?vue&type=template&id=7df1cb90&"
import script from "./gc-button-delete.vue?vue&type=script&lang=js&"
export * from "./gc-button-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports